import { getData } from "@/lib/prismic/data";
import type { ProductDocument } from "@/prismicio-types";

import { retrieveProductByHandleStrict, retrieveProductStrict } from "./medusa/data/products";
import {
  getLinkedMedusaProductId,
  getMedusaLookupHandle,
  selectStorefrontProductDocument,
  type StorefrontPrismicProduct,
} from "./medusa/storefront-product-document";

type StorefrontProductResolution = Pick<Resolution, "locale" | "templateName" | "slugs">;

export const getStorefrontProductDocument = async (
  resolution: StorefrontProductResolution
): Promise<ProductDocument | null> => {
  if (resolution.templateName !== "product") return null;

  const handle = resolution.slugs.at(-1);
  if (!handle) return null;

  const prismicData = await getData(resolution);
  const prismicProduct: StorefrontPrismicProduct | null =
    prismicData?.data && prismicData.type === "product" ? prismicData : null;
  const linkedMedusaId = getLinkedMedusaProductId(prismicProduct);
  const medusaLookupHandle = getMedusaLookupHandle(prismicProduct, handle);
  const productByHandle = await retrieveProductByHandleStrict(medusaLookupHandle);
  const medusaProduct = productByHandle || (linkedMedusaId ? await retrieveProductStrict(linkedMedusaId) : null);

  return selectStorefrontProductDocument({
    prismicProduct,
    medusaProduct,
    locale: resolution.locale,
  });
};
